import React, { FunctionComponent, useState } from "react";
import { Icon, InlineIcon } from "@iconify/react";
import eyeFilled from "@iconify/icons-ant-design/eye-filled";
import eyeInvisibleFilled from "@iconify/icons-ant-design/eye-invisible-filled";
import Input from "../input";
import { theme } from "../../../themes/global";
import styled from "@emotion/styled";
import { HTMLCustomProps } from "../../../types/css";

const Wrapper = styled("div")`
  position: relative;
`;

interface EyeIconProps {
  onClick?: any;
}

const EyeIcon = styled(Icon)<EyeIconProps>`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
`;

interface Props {
  type?: string;
  name?: string;
  value?: string | number;
}

const Password: FunctionComponent<HTMLCustomProps<HTMLInputElement> &
  Props> = ({ onChange, onBlur, value, name, children, ...rest }) => {
  const [type, setType] = useState("password");
  return (
    <React.Fragment>
      <Wrapper {...rest}>
        <Input
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          name={name}
          type={type}
          css={{ width: "100%" }}
        />
        {type === "password" ? (
          <EyeIcon
            onClick={() => setType("text")}
            icon={eyeInvisibleFilled}
            style={{ fontSize: "24px", color: theme.color.dark }}
          />
        ) : (
          <EyeIcon
            onClick={() => setType("password")}
            icon={eyeFilled}
            style={{ fontSize: "24px", color: theme.color.dark }}
          />
        )}
      </Wrapper>
    </React.Fragment>
  );
};

export default Password;
